// App-wide numeric/behavioral constants that were previously duplicated as
// magic numbers across multiple files. These aren't environment-specific
// (same value in dev and production), so they live here rather than in
// .env — see src/utils/Configs.js for the env-driven values.
const AppConstants = {
  // Photo upload (utils/imageUtils.js)
  PHOTO_UPLOAD_MAX_SIZE_MB: 5,
  PHOTO_MIN_WIDTH_PX: 200,
  PHOTO_MIN_HEIGHT_PX: 300,
  PHOTO_COMPRESSION_MAX_DIMENSION_PX: 800,

  // Pagination default (ProfilePhotosApi, AllPhotosApi, ReactTable)
  DEFAULT_PAGE_SIZE: 10,

  // WebSocket (context/WebSocketContext.js)
  WS_HEARTBEAT_INTERVAL_MS: 20000,
  WS_PONG_TIMEOUT_MS: 30000,
  WS_MAX_RECONNECT_BACKOFF_MS: 30000,

  // Calls (context/CallContext.js)
  CALL_TIMEOUT_MS: 30000,

  // Toast/alert auto-dismiss (utils/alerts/sweetAlerts.js and friends)
  TOAST_AUTO_DISMISS_MS: 2000,

  // Subscription (views/Dashboard/RenewSubscription.js). Where expired
  // singles are sent, and the PayPal plans offered — price must match the
  // backend's USD_COST_PER_DAY (USD per 30 days).
  RENEW_SUBSCRIPTION_PATH: "/singles/renew-subscription",
  SUBSCRIPTION_USD_PER_MONTH: 8,
  SUBSCRIPTION_PLAN_MONTHS: [1, 3, 6, 12],
};

export default AppConstants;
